// extracted by mini-css-extract-plugin
export var numpadContainer = "_r5-1";
export var phoneButton = "_r5-0";